// eslint-disable-next-line import/no-extraneous-dependencies
import Swiper from 'swiper/bundle';

// MV
if (document.querySelector('[data-role="special-contents-header-swiper"]') !== null) {
  // eslint-disable-next-line no-new
  let topMvSwiper = new Swiper('[data-role="special-contents-header-swiper"]', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    centerInsufficientSlides: true,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 1500,
    pagination: {
      el: "[data-role='special-contents-header-swiper-pagination']",
      clickable: true,
    },
  });
}
if (document.querySelector('[data-role="special-contents-header-youtube"]') !== null) {
  // YouTube IFrame APIの読み込み
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  // YouTubeプレイヤーの初期化
  window.onYouTubeIframeAPIReady = () => {
    const movieId = document.getElementById('player').dataset.videoId;
    const player = new YT.Player('player', {
      width: 1600,
      height: 900,
      videoId: movieId,
      playerVars: {
        autoplay: 1,
        loop: 1,
        mute: 1,
        playlist: movieId,
        playsinline: 1,
        rel: 0,
        modestbranding: 1,
        controls: 0,
        showinfo: 0,
        enablejsapi: 1,
        origin: window.location.origin,
      },
      events: {
        onReady: (event) => {
          event.target.playVideo();
          document.querySelector('.js-youtube-player').classList.remove('is-hidden');
        },
        onStateChange: (event) => {
          if (event.data === YT.PlayerState.ENDED) {
            event.target.playVideo(); // ループ再生
          }
        },
        onError: (event) => {
          console.error('YouTube player error:', event.data);
        }
      }
    });
  };
}

// パターン14 カルーセル
const specialContentsSectionSwiperElm = document.querySelectorAll('[data-role="special-contents-section-swiper"]');
if (specialContentsSectionSwiperElm.length) {
  specialContentsSectionSwiperElm.forEach((specialContentsSectionSwiper) => {
    const slides = specialContentsSectionSwiper.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;
    const slidesPerView = window.innerWidth >= 1024 ? 3 : 1.4;
    const loopEnabled = slideCount > slidesPerView;
    
    const swiperOptions = {
      swiperPerView: slidesPerView,
      spaceBetween: 16,
      centeredSlides: true,
      loop: slideCount > slidesPerView,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 750,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 32,
          centeredSlides: false,
        },
      },
      navigation: {
        nextEl: specialContentsSectionSwiper.querySelector('[data-role="special-contents-section-swiper-nav-next"]'),
        prevEl: specialContentsSectionSwiper.querySelector('[data-role="special-contents-section-swiper-nav-prev"]'),
      },
      on: {
        init: function(){
          const prevBtn = specialContentsSectionSwiper.querySelector('[data-role="special-contents-section-swiper-nav-prev"]');
          const nextBtn = specialContentsSectionSwiper.querySelector('[data-role="special-contents-section-swiper-nav-next"]');

          if(!loopEnabled) {
            prevBtn.classList.add('is-disabled');
            nextBtn.classList.add('is-disabled');
          } else {
            prevBtn.classList.remove('is-disabled');
            nextBtn.classList.remove('is-disabled');
          }
        },
      },
    };

    new Swiper(specialContentsSectionSwiper, swiperOptions);
  });
}
